import React from 'react';
import { Fab } from '@mui/material';
import { SupportAgent as SupportIcon } from '@mui/icons-material';

const GRADIENT = 'linear-gradient(45deg, #1a237e 30%, #3949ab 90%)';
const GRADIENT_HOVER = 'linear-gradient(45deg, #0d1642 30%, #1a237e 90%)';

const FloatingConsultButton = ({ onClick }) => {
  return (
    <Fab
      variant="extended"
      onClick={onClick}
      sx={{
        position: 'fixed',
        bottom: { xs: 16, md: 24 },
        left: { xs: 16, md: 24 },
        background: GRADIENT,
        color: 'white',
        fontWeight: 'bold',
        zIndex: 1300,
        '&:hover': { background: GRADIENT_HOVER },
      }}
    >
      <SupportIcon sx={{ ml: 1 }} />
      مشاوره
    </Fab>
  );
};

export default FloatingConsultButton;
